"use client";

import { FC } from "react";

/**
 * Page-wide ambient glow — three large blurred radial-gradient orbs
 * pinned to the viewport via `fixed`, drifting slowly via the same
 * `animate-float-a/b/c` keyframes the CTA aurora uses.
 *
 * `mix-blend-screen` means each orb LIGHTENS whatever sits behind it:
 *   - On dark sections (hero, trusted-by strip, stats strip) the orbs
 *     tint the background a soft cyan/violet/emerald.
 *   - On white/light sections the orbs effectively disappear (screen
 *     of any color with white = white), so reading copy on white cards
 *     stays crisp.
 *
 * `pointer-events-none` so the orbs never block clicks. `-z-10` keeps
 * them behind every section but above any solid bg on the layout
 * wrapper.
 *
 * Placed once at the top of the home page; the floating orbs are
 * visible behind every section as the visitor scrolls.
 */
const PageAmbientGlow: FC = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      <div
        className="absolute -left-[10%] top-[8%] h-[55vw] max-h-[680px] w-[55vw] max-w-[680px] animate-float-a rounded-full opacity-70 mix-blend-screen blur-3xl"
        style={{
          background:
            "radial-gradient(closest-side, rgba(56, 189, 248, 0.55), transparent 70%)",
        }}
      />
      <div
        className="absolute right-[-8%] top-[35%] h-[50vw] max-h-[620px] w-[50vw] max-w-[620px] animate-float-b rounded-full opacity-65 mix-blend-screen blur-3xl"
        style={{
          background:
            "radial-gradient(closest-side, rgba(167, 139, 250, 0.55), transparent 70%)",
        }}
      />
      <div
        className="absolute bottom-[5%] left-[20%] h-[45vw] max-h-[560px] w-[45vw] max-w-[560px] animate-float-c rounded-full opacity-60 mix-blend-screen blur-3xl"
        style={{
          background:
            "radial-gradient(closest-side, rgba(52, 211, 153, 0.50), transparent 70%)",
        }}
      />
    </div>
  );
};

export default PageAmbientGlow;
